import ElementSkeleton from "./ElementSkeleton";
import { LoadState, LoadStateInfo, worstState } from "../../redux/common";
import FragmentCardError from "./FragmentCardError";
import { ElementForbidden } from "./ElementForbidden";

export interface CheckLoadingProps {
    content: () => React.ReactNode;
    states: LoadStateInfo[];
    error: React.ReactNode;
    notStarted?: React.ReactNode;
    retry?: () => void;
}
const CheckLoading = ({ content, states, error, notStarted, retry }: CheckLoadingProps) => {
    // console.log(`CheckLoading.states: ${JSON.stringify(states)}`);
    const worst = worstState(states);
    // console.log(`CheckLoading.worst :: ${JSON.stringify(worst.state)}`);
    switch (worst.state) {
    case LoadState.Loaded:
        return content();
    case LoadState.Failed: {
        const forbidden = worst.code == "403";
        // console.log(`CheckLoading.failed: ${worst.code}, forbidden: ${forbidden}`);
        if(forbidden) {
            return <ElementForbidden />;
        }
        return <FragmentCardError error={error} retry={retry}/>;
    }
    case LoadState.NotStarted:
        return notStarted || <ElementSkeleton />;
    default:
        return <ElementSkeleton />;
    }
};

export default CheckLoading;